const $$splitErrorComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/integrations/$provider/callback.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/integrations/$provider/callback.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { oauthCallbackSchema, providerFromSlug } from '../-shared/useOAuthCallback';

// Canonical, provider-parameterized OAuth callback. New providers register only this URI; the Jira
// path is a permanent static alias (static routes take precedence over this dynamic segment).

export const Route = createFileRoute('/(app)/integrations/$provider/callback')({
  params: {
    parse: ({
      provider
    }) => {
      const parsed = providerFromSlug(provider);
      if (!parsed) {
        throw new Error(`Unknown integration provider: ${provider}`);
      }
      return {
        provider: parsed
      };
    },
    stringify: ({
      provider
    }) => ({
      provider: provider.toLowerCase()
    })
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(oauthCallbackSchema),
  loaderDeps: ({
    search: {
      state,
      code
    }
  }) => ({
    state,
    code
  }),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});